import React, { useState } from 'react';
import {
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Typography,
} from '@mui/material';
import { ToastType } from '../interfaces';
import { useToastMessage } from '../hooks/useToastMessage';
import ToastWrapper from './ToastWrapper';
import { resetInstallOnboardDevice } from '../api/resetInstallOnboardDevice';

interface Props {
    open: boolean;
    selectedDeviceId: string;
    onClose: () => void;
    onResetCompleted: () => void;
}

export const ResetInstallDialog = ({ open, onClose, onResetCompleted, selectedDeviceId }: Props) => {
    const [loading, setLoading] = useState(false);
    const [deleteCalibrationFiles, setDeleteCalibrationFiles] = useState(false);
    const { isOpened, toastMessage, setToastMessage, handleCloseToast } = useToastMessage();

    const handleConfirm = async () => {
        setLoading(true);
        try {
            await resetInstallOnboardDevice(selectedDeviceId, deleteCalibrationFiles);
            onResetCompleted();
        } catch (e: any) {
            const message = e?.response?.data?.message ?? 'Не вдалося скинути інсталяцію девайсу';
            setToastMessage({ message, type: ToastType.WARNING });
            setLoading(false);
        }
    };

    return (
        <>
            <Dialog open={open} onClose={loading ? undefined : onClose}>
                <DialogTitle>Reset Install</DialogTitle>
                <DialogContent sx={{ width: 400 }}>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        Ви впевнені, що хочете скинути інсталяцію девайсу <strong>{selectedDeviceId}</strong>?
                    </Typography>
                    <Typography variant="body2" color="warning.main" gutterBottom>
                        Буде відкликано VPN, видалено флешки та очищено всі поля інсталяції.
                    </Typography>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={deleteCalibrationFiles}
                                onChange={(e) => setDeleteCalibrationFiles(e.target.checked)}
                                disabled={loading}
                            />
                        }
                        label="Видалити файли калібрування"
                    />
                </DialogContent>
                <DialogActions>
                    <Button disabled={loading} variant="outlined" color="inherit" onClick={onClose}>
                        Скасувати
                    </Button>
                    <Button
                        disabled={loading}
                        variant="outlined"
                        color="error"
                        onClick={handleConfirm}
                        startIcon={loading ? <CircularProgress size={15} /> : undefined}
                    >
                        Скинути
                    </Button>
                </DialogActions>
            </Dialog>
            <ToastWrapper
                open={isOpened}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                autoHideDuration={4000}
                onClose={handleCloseToast}
                message={toastMessage?.message}
                type={toastMessage?.type}
            />
        </>
    );
};
